import React from 'react';

const LocationIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z"
      stroke="#c6a664"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1.33334C6.58551 1.33334 5.22896 1.89525 4.22876 2.89544C3.22857 3.89563 2.66667 5.25219 2.66667 6.66668C2.66667 8.05334 2.94 8.88668 3.66667 9.86668L8 14.6667L12.3333 9.86668C13.06 8.88668 13.3333 8.05334 13.3333 6.66668C13.3333 5.25219 12.7714 3.89563 11.7712 2.89544C10.771 1.89525 9.41449 1.33334 8 1.33334Z"
      stroke="#c6a664"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LocationIcon;
